import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DistributorComponent } from './distributor.component';
import { DistributorService } from './distributors.service';
import { SharedModule } from '../shared/shared.module';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { GoogleMapsModule } from '@angular/google-maps';
import { DistributorRoutingModule } from './distributor-routing.module';
import { SwiperModule } from 'swiper/angular';
import { ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';

@NgModule({
  imports: [DistributorRoutingModule, CommonModule, SharedModule, MatFormFieldModule, MatSelectModule, MatInputModule, ReactiveFormsModule, GoogleMapsModule, SwiperModule],
  declarations: [DistributorComponent],
  exports: [DistributorComponent],
  providers: [DistributorService]
})
export class DistributorModule { }
